import React from 'react';
import { jwtDecode } from 'jwt-decode';
import NotAuthorized from '../src/Components/NotAuthorised/NotAuthorised';
import NotAuthorizedExternal from '../src/Components/NotAuthorised/NotAuthorisedExternal';

const getUserRoles = () => {
  const token = localStorage.getItem(process.env.REACT_APP_CIAM_ACCESS_KEY);
  if (!token) return [];
  try {
    const decoded = jwtDecode(token);
    let roles = decoded?.roles || [];
    if (typeof roles === 'string') {
      roles = roles.split(',').map(r => r.trim());
    }
    return roles.map(r => r.toLowerCase());
  } catch (error) {
    console.error('Invalid token', error);
    return [];
  }
};

const getUserEmail = () => {
  const token = localStorage.getItem(process.env.REACT_APP_CIAM_ACCESS_KEY);
  if (!token) return null;
  try {
    const decoded = jwtDecode(token);
    return decoded?.email?.toLowerCase() || null;
  } catch {
    return null;
  }
};

const allAllowedRoles = [
  'idamaerskcx',
  'maerskinternal',
  'idavestasapprover',
  'idavestasviewer',
  'idamaerskbilling',
  'idamaerskviewer'
];

const ProtectedRoute = ({ children, allowedRoles, allowedEmails }) => {
  const userRoles = getUserRoles();
  const allowed = allowedRoles ? allowedRoles.map(r => r.toLowerCase()) : [];

  // External user or BasicSoftUser check
  if (
    userRoles.includes('basicsoftuser') ||
    !userRoles.some(role => allAllowedRoles.includes(role))
  ) {
    return <NotAuthorizedExternal />;
  }

  // Email-based access check (used for admin-only routes like Approver Matrix)
  if (allowedEmails && allowedEmails.length > 0) {
    const userEmail = getUserEmail();
    if (!userEmail || !allowedEmails.includes(userEmail)) {
      return <NotAuthorized />;
    }
    return children;
  }

  // Role-based access check
  const isAuthorized = userRoles.some(role => allowed.includes(role));

  if (!isAuthorized) {
    return <NotAuthorized />;
  }

  return children;
};

export default ProtectedRoute;
